export class ModelStock {
  constructor () {
    this.id = null
    this.partID = null
    this.partSN = ''
    this.qty = 1
    this.minQty = null
    this.entryDate = new Date()
    this.nonIncident = false
    this.supplierPaymentDate = null

    // tag info
    this.conditionID = null
    this.releaseID = null
    this.tagDate = ''
    this.tagInfoCompanyID = null
    this.traceabilityCompanyID = null
    this.shelfLifeLimit = ''
    this.altPartID = null
    this.weightDimensions = ''

    // TODO: Remarks
    this.stockRemark = ''
    this.stockTechnicalRemark = ''
    this.salesRemarkID = null
    this.salesRemark = ''
    this.sellPrice = null
    this.exchPrice = null
    this.sellExchPriceDate = new Date()
    this.sellExchCurrencyID = null

    // TODO: Location
    this.stockLocationID = null
    this.warehouseLocationID = null
    this.externalLocationCompanyID = null

    // TODO: Status
    this.statusID = null
    this.statusInd = ''// TODO: not sure
    this.statusDate = ''

    // TODO: Supplier
    this.supplierCompanyID = null
    this.ownerCompanyID = null
    this.baxpoNumber = null
    this.supplierOrderDate = ''
    this.accountingValue = null
    this.accountingValueCurrencyID = null
    this.partPrice = null
    this.priceCurrencyID = null

    // TODO: Medias
    this.ppwPath = ''
    this.ppwAttached = ''
    this.photoAttached = ''
  }
}
